import { NgModule } from '@angular/core';
import {NoSpaceDirective} from "./no-space.directive";

@NgModule({
  declarations: [NoSpaceDirective],
  exports: [NoSpaceDirective]
})
export class DirectivesModule { }
